import { CommonModule, CurrencyPipe, NgOptimizedImage } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../../environments/environment';
import { AppRoutingModule } from '../app-routing.module';
import { EmptyCalendarSpaceInteractionDirective } from '../features/calendar/components/time-block/interaction/empty-calendar-space-interaction.directive';
import { ShivePopupDirective } from './directives/shive-popup.directive';
import { MemberNamePipe } from './pipes/member-name.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { ShiveCurrencyPipe } from './pipes/shive-currency.pipe';
import { AdminLayoutRoutes } from './routing/routes/admin-layout.routes';
import { effects, initialState, metaReducers, reducers } from './state/app.state';

@NgModule({
  declarations: [EmptyCalendarSpaceInteractionDirective],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    EmptyCalendarSpaceInteractionDirective,
    ShiveCurrencyPipe,
    SafeHtmlPipe,
    MemberNamePipe,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule.forChild(AdminLayoutRoutes),
    EffectsModule.forRoot(effects),
    StoreModule.forRoot(reducers, {
      initialState,
      metaReducers,
    }),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
    }),
    NgOptimizedImage,
    FaIconComponent,
    ShivePopupDirective,
    ShiveCurrencyPipe,
    SafeHtmlPipe,
    MemberNamePipe,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    CurrencyPipe,
    {
      provide: 'wsUri',
      useValue: 'ws://localhost:8002/ws/tracker/',
    },
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
    }
  }
}
